module.exports = "/* .no-data-skin{\r\n    text-align: center;\r\n     font-weight: bold;\r\n     position: absolute;\r\n     top: 50%;\r\n     width: 100%; \r\n     color: #999999;\r\n     font-size: 17px;    \r\n    } */\r\n\r\n.btn-marron {\r\n    margin-right: 25px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dashboard/announcement/announcement.component.css
// module id = ./src/app/modules/dashboard/dashboard/announcement/announcement.component.css
// module chunks = dashboard.module